import { render, staticRenderFns } from "./apartment-price-table.vue?vue&type=template&id=0cce15a0&scoped=true&"
import script from "./apartment-price-table.ts?vue&type=script&lang=ts&"
export * from "./apartment-price-table.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-price-table.scss?vue&type=style&index=0&id=0cce15a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cce15a0",
  null
  
)

export default component.exports